import 'url-search-params-polyfill';

import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { DndProvider } from 'react-dnd';
import TouchBackend from 'react-dnd-touch-backend';
import HTML5Backend from 'react-dnd-html5-backend';
import { RecoilRoot } from 'recoil';

import { useSiftScience } from '@zg-rentals/sift-science';
import { ThemeConstellation } from '@zillow/constellation';
import { ToastProvider } from '@zillow/constellation-10';
import { useRentalManagerUser } from '@zg-rentals/rental-manager-env';
import { useRegisterNotification } from '@zg-rentals/register-notification';

import getRouter from '../utils/routes';
import { getFullStoryInstance } from '../utils/fullstory';
import { FULLSTORY_UNMASK } from '../constants/analytics';
import { useComscorePageTracking } from '@zg-rentals/comscore';
import { trackComscoreEvent } from '../../analytics';

function App() {
  const { user } = useRentalManagerUser();
  const history = useHistory();

  useSiftScience({ email: user?.email, isImpersonator: Boolean(user?.impersonatorUserToken) });
  useComscorePageTracking(() => trackComscoreEvent({}), history.location.pathname);

  useEffect(() => {
    getFullStoryInstance(user.userToken);
  }, [user]);

  useRegisterNotification({
    ref: 'LEASING_WEB',
  });

  return (
    <>
      <Helmet>
        <title>{`Leases | Zillow Rental Manager`}</title>
      </Helmet>
      <div className={FULLSTORY_UNMASK}>
        <RecoilRoot>
          <ToastProvider placement="bottom">
            <StyledComponentsThemeProvider theme={ThemeConstellation}>
              {'ontouchstart' in document.documentElement ? (
                // @ts-expect-error - DndProvider types don't match TouchBackend
                <DndProvider backend={TouchBackend}>{getRouter(history)}</DndProvider>
              ) : (
                // @ts-expect-error - DndProvider types don't match HTML5Backend
                <DndProvider backend={HTML5Backend}>{getRouter(history)}</DndProvider>
              )}
            </StyledComponentsThemeProvider>
          </ToastProvider>
        </RecoilRoot>
      </div>
    </>
  );
}

export default App;
